import { fetchPhpEigth } from 'api';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { urlTrackingLeadsV2 } from 'constants/urls';

/**
 *
 * @deprecated Esta funcion se debe reemplazar por: `guardarTrackingV2`
 *
 * @param {*} url
 * @param {*} idCotizacion
 * @param {*} accion
 * @param {*} paso
 * @param {*} urlTracking
 */
export const guardarTracking = (url, idCotizacion, accion, paso, urlTracking) => {
  try {
    fetchPhpEigth(url, { idCotizacion, accion, paso, url: urlTracking });
  } catch (error) {}
};

const API = ApiKeyFetch.instance();

/**
 *
 * @param {string} url
 * @param {string} idCotizacion
 * @param {string} accion
 * @param {string} paso
 * @param {string} url
 */
export const guardarTrackingV2 = async (idCotizacion, accion, paso, url = urlTrackingLeadsV2) => {
  try {
    API.post(url, { idCotizacion, accion, paso, url: window.location.href });
  } catch (error) {}
};
